import { render, staticRenderFns } from "./ServicesDataTable.vue?vue&type=template&id=7c6c99dd"
import script from "./ServicesDataTable.vue?vue&type=script&lang=js"
export * from "./ServicesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports